import { render, staticRenderFns } from "./RegistrationCompletionForm.vue?vue&type=template&id=536b3c50&scoped=true"
import script from "./RegistrationCompletionForm.vue?vue&type=script&lang=js"
export * from "./RegistrationCompletionForm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationCompletionForm.vue?vue&type=style&index=0&id=536b3c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b3c50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})
